// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XuqOzs91YH6Jk5pg93z3{width:100%;cursor:move}`, "",{"version":3,"sources":["webpack://./ui-kit/Modals/DraggableModal/DraggableModal.module.scss"],"names":[],"mappings":"AAAA,sBACE,UAAA,CAEA,WAAA","sourcesContent":[".draggableTitle {\r\n  width: 100%;\r\n  //height: 100%;\r\n  cursor: move;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"draggableTitle": `XuqOzs91YH6Jk5pg93z3`
};
export default ___CSS_LOADER_EXPORT___;
